import React, { useState, useEffect, useLayoutEffect } from 'react';
import FormControl from '@mui/material/FormControl';

import { useLocation, useNavigate } from 'react-router-dom';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { Helmet } from 'react-helmet-async';

import {
  InputAdornment,
  Typography,
  Button,
  Stack,
  Box,
  TextField,
  Divider,
  Modal,
  Grid,
  MenuItem,
  InputLabel,
  Select,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  
} from '@mui/material';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Iconify from '../components/iconify';
// import Upload from '../components/upload';
import Scrollbar from '../components/scrollbar/Scrollbar';
import countries from './countryJson/countryJson.json';
import { Api, UploadFile } from '../webservices';

import CustomComplete from '../components/customComplete/CustomComplete';

function ApplyJobPreview() {
  const location = useLocation();
  // console.log("locationnn====>",location)
  const navigate = useNavigate();

  const filter = createFilterOptions();
  console.log("hello shyamlal sharma ====>>", location.state)
 
  const [row, setRow] = React.useState({ ...location.state?.row });

  console.log("hello shyamlal sharma ji ====>>",row )
 
  const [skillss, setSkillss] = React.useState([...(location.state?.addedSkills || location.state?.addedSkill || [])]);

  const [skilllst, setSkilllst] = useState(
    (row?.skill || [])?.filter((skill) => skill)?.map((skill) => ({ title: skill }))
  );

  const [cityStateStylings, setTityStateStyling] = useState(location.state?.cityStateStyling);
  
//   const [value, setValue] = React.useState("Detail");

  const [tabb, setTabb] = React.useState(location.state?.kTab ? location.state?.kTab : 'Action');
  // const [tabb, setTabb] = React.useState("Hide");
  const [value1, setValue1] = React.useState("Detail");
  
  const [resumeArry, setResumeArry] = useState([]);
  const [resumeUrl, setResumeUrl] = useState();
 const [buttonDisable,setButtonDiable]=useState(false);
  const [upnote, setUpnote] = useState();
  
  const [box1, setBox1] = useState({
    source: row?.source ? row?.source : '',
    currentStatus: row?.status ? row?.status : '',
    candidateName: row?.fullName ? row?.fullName : '',
    candidateid: row?.candidateId ? row?.candidateId : '',
    linkedin: row?.linkedinUrl ? row?.linkedinUrl : '',
    box1email: row?.email ? row?.email : '',
    box1SeconEemail: row?.secondaryEmail ? row?.secondaryEmail : '',
    box1phone: row?.phone ? row?.phone : '',
    box1SecondPhone: row?.secondaryPhone ? row?.secondaryPhone : '',
    box1address: row?.address ? row?.address : '',
    box1compensation: row?.expectedCompensation ? row?.expectedCompensation : '',
    box1ChargeType: row?.chargeType ? row?.chargeType : '',

    box1visaType: row?.visaType ? row?.visaType : '',
    box1reallocate: row?.reallocate ? row?.reallocate : '',
    box1domain: row?.domain ? row?.domain : '',
    box1taxTerm: row?.taxTerm ? row?.taxTerm : '',
    box1jobTitle: row?.jobTitle ? row?.jobTitle : '',
    box1city: row?.address ? row?.address : '',
    // box1Country: row?.country ? row?.country : "",
    box1Currcompany: row?.currentCompany ? row?.currentCompany : '',
    // box1Country: row?.country ? row?.country : localStorage.getItem("country"),
    // box1Country: localStorage.getItem("country"),

     box1Country:row?.country,
    box1Notes: row?.note ? row?.note : '',
    box1City: row?.city ? row?.city : '',
    box1ResumeUrl: row?.resumeUrl ? row?.resumeUrl : '',
    box1linkedinUrl:row?.linkedinUrl ? row?.linkedinUrl : ''
  });

  const cardbg = '';

  useLayoutEffect(() => {
    
    getResumes();
  }, []);

  const getResumes = async () => {
    const token = localStorage.getItem('token');
    Api(`resume/resumes_by_candidate/${location.state?.Id?.resumeId}`, 'GET', '', token)
      .then((response) => {
        // console.log('==========resumes_by_candidate=====>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setResumeArry(response.data.data);
            // if(!row?.resumeUrl){
            // }
            setResumeUrl(response.data.data[0].resumeUrl);
          }
        }
      })
      .catch((err) => { });
  };


  const editResume = () => {
   
    const skillLst = [];
    skilllst?.map((item) => {
      return skillLst?.push(item?.title?.toLowerCase());
    });
    // console.log('after map skill', skillLst);

    const uniqueSkillLst = [...new Set(skillLst)];

    const id = row?._id;
    const token = localStorage.getItem('token');

    if (!box1.candidateName) {
      toast.error('Full Name is Required');
      return;
    }
    if (!box1.box1email) {
      toast.error('Email is Required');
      return;
    }

    if (!cityy) {
      toast.error('City & Pincode are required');
      return;
    }

    if (!box1.box1jobTitle) {
      toast.error('Job Title is Required');
      return;
    }

    const body = {
      newCV: 'no',
      resumeId: id,
      fullName: box1.candidateName,
      email: box1.box1email,
      jobTitle: box1.box1jobTitle,
      phone: box1.box1phone,
      currentCompany: box1.box1Currcompany,
      skill: uniqueSkillLst,
      visaType: box1.box1visaType,
      taxTerm: box1.box1taxTerm,
      expectedCompensation: box1.box1compensation,
      cityOrZipcode: cityy,

      zipcode: valueee?.zip,
      stateCode: cityandstate?.stateCode,
      reallocate: box1.box1reallocate,
      resumeUrl: box1.box1ResumeUrl,
    
      chargeType: box1.box1ChargeType,
      // userStatus: value.userStatus,
      country: box1.box1Country,
       linkedinUrl: box1.box1linkedinUrl,
    };

    Api(`resume/update_resume`, 'POST', body, token)
      .then((Response) => {
        // console.log('======getUser==response=====>', Response);
        if (Response.status === 200) {
          if (Response.data.code === 200) {
              applyJob(location.state?.Id)
              // toast.success(Response.data.message);
              // navigate(-1);

            // console.log('======getUser===data.data pdata====>', Response);
          } else {
            // console.log('======getUser=======>', +Response);
            toast.warn(Response.data.message);
            // enqueueSnackbar(Response.data.message);
          }
        }

        // toast.error("Email, fullName, and jobTitle are required fields");
      })
      .catch((err) => {
        toast.error(err, +'!');
        // console.log('===========', err);
      });
  };
  
  const suru = 'https://docs.google.com/viewer?url=';
  const lll = '&embedded=true';
  const tempDoc = 'https://file-examples.com/storage/fe9d743740654a8139a48e1/2017/02/file-sample_100kB.docx';

  const visalist = [
    { label: 'USC' },
    { label: 'GC' },
    { label: 'GCEAD' },
    { label: 'TN' },
    { label: 'H1B' },
    { label: 'H1b I 140 ' },
    { label: 'H4 EAD' },
    { label: 'OPT EAD' },
    { label: 'CPT EAD' },
    { label: 'E2 Visa' },
    { label: 'B 1 Visa' },
    { label: 'Canadian citizen' },
    { label: 'Open work permit' },
    { label: 'Permanent Resident' },
  ];

  const [cityData, setcityData] = useState([]);
  const [cityandstate, setCityandstate] = useState(row);

   const [cityy, setCityy] = useState(row?.city);


  const childFuc = (e) => {
    setcityData([]);
    setCityy(e);
    if (e.length >= 3) {
      getCity(e);
    } else if (e.length === 0) {
      setCityy(e);
      setcityData([]);
      setCityandstate({});
    }
  };

  const [valueee, setValueee] = useState('');
  const fullVal = (val) => {
    // console.log(val);
    setCityandstate(val);
    setCityy(val.city);
    setValueee({ ...valueee, zip: val?.zip || val.postal });
  };

  const [err, setErr] = useState(false);
  const [helperText, setHelperText] = useState('');

  const getCity = async (val) => {
    setHelperText('');
    setErr(false);
    setcityData([]);
    const token = localStorage.getItem('token');
    const body = {
      // country: value.country,
      country: box1.box1Country,
      query: val,
    };
    Api(`resume/get_city_states`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========status 200======>>>>>>>', response);
          if (response.data.code === 200) {
            // console.log('city========', JSON.stringify(response.data));
            setcityData(response.data.data);
          } else {
            setHelperText('No cities found for the given city name.');
            setErr(true);

            // toast.error(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

 const applyJob = async (id) => {

   setButtonDiable(true)
    const token = localStorage.getItem('token');
    const body = {
       jobId: id?.jobId,
      resumeId: id?.resumeId,
      companyID:location.state.Id.companyid,
       email:location.state.row.email
    };
    Api(`common/applyForJob`, 'POST', body, token)
      .then((response) => {
         console.log('==========res=====>>>', response);
        if (response.status === 200) {
            //  toast.success(response?.data?.message);
          if (response.data.code === 200) {

                toast.success(response?.data?.message);
             setTimeout(()=>{
              navigate(-1);
             },4000)
           
          }
          else if(response.data.code === 201)
          {
                 toast.warn(response?.data?.message);
                  setTimeout(()=>{
              navigate(-1);
             },4000)
          }
          
          else {
                  toast.warn(response.data.message);
          }
        }
      
        
      })
      .catch((err) => { });
  };

  const disclaimer = `Disclaimer:
    By submitting your resume, you expressly consent to being contacted by the respective recruitment
 professional via phone call, SMS, WhatsApp, or email regarding suitable job opportunities, interview
  schedules, application updates,and other recruitment-related communications. Your personal information
   will be processed solely for recruitment purposes in accordance with our Privacy Policy.`;
  return (
    <>
      <Helmet>
        <title> Apply Job Preview | Foxearch </title>
      </Helmet>

      <ToastContainer />

<Stack sx={{p:2}}>

      <Stack sx={{ flexDirection: 'row', paddingLeft:1, paddingRight:1, justifyContent: 'space-between' }}>
        <Stack sx={{ flexDirection: 'row' }}>
          <Iconify
            icon="ion:arrow-back"
            fontSize={25}
            sx={{ cursor: 'pointer', color: 'text.secondary', fontSize: '0.9rem', fontWeight: '600', mr: 1 }}
            onClick={() => navigate(-1)}
          />

          <Typography
            color={'text.secondary'}
            style={{ textDecoration: 'underline', cursor: 'pointer', fontSize: '0.9rem', fontWeight: '600' }}
            onClick={() => navigate(-1)}
          >
            Apply Job Preview
          </Typography>
          
        </Stack>
      </Stack>

      <Grid sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' } }}>
        <Box sx={{ width: { xs: '100%', lg: '50%' }, p: 1 }}>
          <Scrollbar>
            <Stack sx={{ border: 2, borderColor: 'text.secondary', borderRadius: 1 }}>
              
              <iframe
                title="resume"
                src={suru + (resumeUrl || box1.box1ResumeUrl) + lll}
                allow="clipboard-read; clipboard-write"
                width="100%"
                height="650px"
                frameBorder="0"
                onLoad
              >
                {resumeUrl || box1.box1ResumeUrl}
              </iframe>
            </Stack>

            <Divider />
          </Scrollbar>
        </Box>
        <Box sx={{ width: { xs: '100%', lg: '50%' }, ml: 1 }}>
          <Stack sx={{ flexDirection: 'row', gap: 2, mb: 2, cursor: 'pointer' }}>
           
            {/* <Stack
              sx={[
                { flexDirection: 'row' },
                value === 'Detail' ? { borderBottom: 2, color: 'text.secondary' } : { color: 'text.textG' },
              ]}
              onClick={() => {
                setValue('Detail');
              }}
            >
              <Iconify icon="mingcute:user-4-fill" sx={{ mb: 0.5 }} fontSize={20} />
              <Typography sx={{ ml: 0.5, mb: 0.5, fontSize: '0.9rem', fontWeight: '600' }}>Detail</Typography>
            </Stack>
             */}
            
          </Stack>
          
          {/* {value === 'Detail' ? (
            <> */}
              <Stack sx={{ backgroundColor: 'text.background', borderRadius: 2, boxShadow: 3, paddingTop: 3, mt:-1 }}>

                <Stack sx={{ flexDirection: 'row', px: 1, backgroundColor: cardbg }}>
                  <Typography fontWeight={500} sx={{ p: 1, width: '50%', color: 'text.secondary' }}>
                    Candidate ID
                  </Typography>
                  
                    <TextField
                      size="small"
                      sx={{ width: '60%', py: 0.5, ml: -12 }}
                      value={box1?.candidateid || ''}
                      onChange={(e) => setBox1({ ...box1, candidateid: e.target.value })}
                    />
                 
                </Stack>

                <Divider />
                <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  <Typography fontWeight={500} sx={{ p: 1, width: '50%', color: 'text.secondary' }}>
                    Candidate Name
                  </Typography>
                  
                    <TextField
                      size="small"
                      sx={{ width: '60%', py: 0.5, ml: -12 }}
                      value={box1?.candidateName || ''}
                      onChange={(e) => setBox1({ ...box1, candidateName: e.target.value })}
                    />
                 
                </Stack>
                <Divider />

                <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  <Typography fontWeight={500} sx={{ p: 1, width: '50%', color: 'text.secondary' }}>
                    Email
                  </Typography>
                  
                    <TextField
                    
                      size="small"
                      sx={{ width: '60%', py: 0.5, ml: -12 }}
                      value={box1?.box1email || ''}
                      onChange={(e) => setBox1({ ...box1, box1email: e.target.value })}
                    />
                 
                </Stack>
                <Divider />
                   <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  <Typography fontWeight={500} sx={{ p: 1, width: '50%', color: 'text.secondary' }}>
                   Linkedin Url
                  </Typography>
                  
                    <TextField
                      size="small"
                      sx={{ width: '60%', py: 0.5, ml: -12 }}
                      value={box1?.box1linkedinUrl || ''}
                      onChange={(e) => setBox1({ ...box1, box1linkedinUrl: e.target.value })}
                    />
                 
                </Stack>
                <Divider />
                <Stack sx={{ flexDirection: 'row', px: 1, backgroundColor: cardbg }}>
                  <Typography fontWeight={500} sx={{ p: 1, width: '50%', color: 'text.secondary' }}>
                    Contact
                  </Typography>
                  
                    <TextField
                      size="small"
                      sx={{ width: '60%', py: 0.5, ml: -12 }}
                      value={box1?.box1phone || ''}
                      onChange={(e) => setBox1({ ...box1, box1phone: e.target.value })}
                    />
                 
                </Stack>
                <Divider sx={{ mb: 0.5 }} />
                <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  
                  <Typography color={'text.secondary'} sx={{ p: 1, width: '50%' }}>
                    Visa Type
                  </Typography>
                 
                    <FormControl variant="outlined" size="small" sx={{ width: '60%', ml: -12 }}>
                      <InputLabel>Visa Type</InputLabel>
                      <Select
                        label="Visa Type"
                       
                        value={box1.box1visaType}
                        onChange={(e) => setBox1({ ...box1, box1visaType: e.target.value })}
                      >
                        {visalist?.map((item, index) => (
                          <MenuItem key={index} value={item?.label}>
                            {item?.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                 
                </Stack>

                <Divider sx={{ mb: 1, mt: 0.5 }} />
                <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  <Typography
                    color={'text.secondary'}
                    // sx={{ p: 1, width: '34%',mt:4 }}
                    sx={{
                      p: 1,
                      width: '34%',
                      mt: 0.9,
                    }}
                  >
                    Skills
                  </Typography>
                  
                    <Autocomplete
                      multiple
                      id="tags-outlined"
                      onChange={(event, newValue) => {
                        setSkilllst([...newValue]);
                      }}
                      options={skillss}
                      getOptionLabel={(option) => option?.title || ''}
                      value={skilllst}
                      filterSelectedOptions
                      filterOptions={(options, params) => {
                        const filtered = filter(options, params);
                        const { inputValue } = params;
                        const isExisting = options?.some((option) => inputValue === option?.title);
                        if (inputValue !== '' && !isExisting) {
                          filtered.push({
                            inputValue,
                            title: `${inputValue}`,
                          });
                        }
                        return filtered;
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Skills"
                          placeholder="Skills"
                          sx={{
                            ml:0.9,
                            width: '380px',
                            '& .MuiInputBase-root': {
                              minHeight: '56px',
                              maxHeight: 'auto',
                              overflowY: 'auto',
                            },
                          }}
                        />
                      )}
                      sx={{
                        width: '50%',
                      }}
                    />
                 
                </Stack>

                <Divider sx={{ mt: 1, mb: 1 }} />
                <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  
                  <Typography fontWeight={500} sx={{ p: 1, width: '50%', color: 'text.secondary' }}>
                    Compensation Type
                  </Typography>

                    <FormControl fullWidth variant="outlined" size="small" sx={{ width: '60%', ml: -12 }}>
                      <InputLabel id="demo-simple-select-label">Compensation Type</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={box1.box1ChargeType}
                        label="Compensation Type"
                        onChange={(e) => setBox1({ ...box1, box1ChargeType: e.target.value })}
                     
                      >
                        <MenuItem value={'hourly'}>Per hour Rate </MenuItem>
                        <MenuItem value={'Annually'}>Annual Compensation</MenuItem>
                      </Select>
                    </FormControl>
                
                </Stack>
                <Divider sx={{ mt: 1, mb: 1 }} />
                <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  <Typography fontWeight={500} sx={{ p: 1, width: '50%', color: 'text.secondary' }}>
                    Expected Compensation
                  </Typography>

                    <TextField
                      size="small"
                      // width="60%"
                      sx={{ width: '60%', py: 0.5, ml: -12 }}
                      id="outlined-basic"
                      // label="Expected Compensation( In Dollars )*"
                      label={`Expected Compensation( In ${box1.box1Country === "INDIA" ? "INR" : "Dollars"} )*`}
                      placeholder="Expected Compensation"
                      variant="outlined"
                      type="text"
                      InputLabelProps={{ shrink: true }}
                      value={box1?.box1compensation}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">{box1.box1Country === "INDIA" ? "₹" : box1.box1Country === "UK" ? "£" : "$"}</InputAdornment>,
                        endAdornment: box1?.box1ChargeType && (
                          <InputAdornment position="end">
                            {box1?.box1ChargeType === 'hourly' ? 'per/hour' : box1.box1Country === "INDIA" ? 'Lac':'K'}
                          </InputAdornment>
                        ),
                      }}
                     
                      onChange={(e) => {
                        const newValue = e.target.value;
                        if (/^\d*\.?\d*$/.test(newValue)) {
                          setBox1({ ...box1, box1compensation: newValue });
                        }
                      }}
                    />
                 
                </Stack>
                <Divider sx={{ mt: 1, mb: 1 }} />

                <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  <Typography color={'text.secondary'} sx={{ p: 1, width: '50%' }}>
                    Country
                  </Typography>
                  
                    <FormControl variant="outlined" size="small" sx={{ width: '60%', ml: -12 }}>
                      <InputLabel id="demo-simple-select-label">Select Country</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={box1.box1Country}
                        // value={country}
                        label="Select Country"
                        // onChange={(e) => setCountry(e.target.value)}
                        onChange={(e) => setBox1({ ...box1, box1Country: e.target.value })}
                      // setCountry(e.target.value)}}
                      >
                        
                        {countries?.map((item) => (
                          <MenuItem key={item.id} value={item.country}>
                            {item.country}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                
                </Stack>
                <Divider sx={{ mt: 1, mb: 1 }} />

                <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  <Typography color={'text.secondary'} sx={{ p: 1, width: '50%' }}>
                    City & Pincode
                  </Typography>
                  
                    <FormControl variant="outlined" size="small" sx={{ width: '60%', ml: -12 }}>
                      <CustomComplete
                        placeholder={'City & Pincode'}
                        option={cityData}
                        propVal={cityy}
                        childFuc={childFuc}
                        fullVal={fullVal}
                        fetch={'state'}
                        cityStateStyling1={cityStateStylings}
                        err={err}
                        helperText={helperText}
                      />
                    </FormControl>
                 
                </Stack>

                <FormControl size="small">
                  {cityandstate ? (
                    <Stack sx={{ ml: 26, flexDirection: 'row' }}>
                      {tabb === 'Hide' && (
                        <Typography color={'text.textG'} variant="body">
                          {cityandstate.state},{' '}
                        </Typography>
                      )}
                      {tabb === 'Hide' && (
                        <Typography color={'text.textG'} variant="body" sx={{ ml: 0.7 }}>
                          {cityandstate.stateCode}
                          {/* {console.log("=====cityandstate.state===>>>", cityandstate.state)} */}
                        </Typography>
                      )}
                    </Stack>
                  ) : null}
                </FormControl>
                <Divider sx={{ mb: 0.5, mt: 0.5 }} />
                <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  <Typography color={'text.secondary'} sx={{ p: 1, width: '50%' }}>
                    Zip Code
                  </Typography>
                  
                    <FormControl variant="outlined" size="small" sx={{ width: '60%', ml: -12 }}>
                     
                      <TextField
                        size="small"
                        
                        value={valueee?.zip}
                        // type="number"
                        onChange={(e) => setValueee({ ...valueee, zip: e.target.value })}
                      />
                     
                    </FormControl>
                  
                </Stack>
               
                <Divider sx={{ mt: 0.5, mb: 0.5 }} />
                <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  <Typography color={'text.secondary'} sx={{ p: 1, width: '50%' }}>
                    Relocate
                  </Typography>
                  
                    <FormControl variant="outlined" size="small" sx={{ width: '60%', ml: -12 }}>
                      <InputLabel>Relocate</InputLabel>
                      <Select
                        label="Relocate"
                        
                        value={box1.box1reallocate}
                        onChange={(e) => setBox1({ ...box1, box1reallocate: e.target.value })}
                      >
                       
                        <MenuItem value={'yes'}> Yes</MenuItem>
                        <MenuItem value={'no'}> No</MenuItem>
                      </Select>
                    </FormControl>
                 
                </Stack>
                <Divider sx={{ mb: 0.5, mt: 0.5 }} />
                

                {
                        

                     localStorage.getItem("country") !== "INDIA"  &&  (<Stack sx={{ flexDirection: 'row', px: 1 }}>
                  <Typography color={'text.secondary'} sx={{ p: 1, width: '50%' }}>
                    Tax Term
                  </Typography>

                    <>
                      <FormControl sx={{ ml: -7 }}>
                       
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="c2c"
                          disabled={value1 !== 'Detail'}
                          name="radio-buttons-group"
                          value={box1.box1taxTerm}
                          onChange={(e) => setBox1({ ...box1, box1taxTerm: e.target.value })}
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            ml: 1,
                          }}
                        >
                          <FormControlLabel value="c2c" control={<Radio />} label="C2C" />
                          <FormControlLabel value="w2" control={<Radio />} label="W2" />
                          <FormControlLabel value="1099" control={<Radio />} label="1099" />
                          <FormControlLabel value="T4" control={<Radio />} label="T4" />
                          <FormControlLabel value="INC" control={<Radio />} label="INC" />
                          <FormControlLabel value="fulltime" control={<Radio />} label="Full-Time" />
                        </RadioGroup>
                      </FormControl>
                    </>
                 
                         </Stack>) 
                }
               











                <Divider />
                <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  <Typography color={'text.secondary'} sx={{ p: 1, width: '50%' }}>
                    Job Title
                  </Typography>
                  
                    <TextField
                      size="small"
                      sx={{ width: '60%', py: 0.5, ml: -12 }}
                      value={box1?.box1jobTitle || ''}
                      onChange={(e) => setBox1({ ...box1, box1jobTitle: e.target.value })}
                    />
                 
                </Stack>

                <Divider />
                <Stack sx={{ flexDirection: 'row', px: 1 }}>
                  <Typography color={'text.secondary'} sx={{ p: 1, width: '50%' }}>
                    Current Company
                  </Typography>
                  
                    <TextField
                      size="small"
                      sx={{ width: '60%', py: 0.5, ml: -12 }}
                      value={box1?.box1Currcompany || ''}
                      onChange={(e) => setBox1({ ...box1, box1Currcompany: e.target.value })}
                    />
                 
                </Stack>
                <Divider />

                <Stack sx={{ p: 2 }}>
                  <Stack justifyContent={'space-between'} flexDirection={'row'} width={'100%'}>
                    <Typography color={'text.secondary'}>Note...(max 2000 char)</Typography>
                    
                  </Stack>
               
                </Stack>
                
                  <Stack px={2} gap={2} mb={2} alignItems={'center'}>

                    
{/*                     
                    <TextField
                      id="outlined-multiline-static"
                      value={upnote}
                     
                      multiline
                      rows={4}
                      sx={{ width: '100%' }}
                      // defaultValue={upnote}
                      onChange={(e) => setUpnote(e.target.value)}
                    /> */}
                    <TextField
                         multiline
                         rows={6}
                         fullWidth
                         value={disclaimer}
                        InputProps={{
                             readOnly: true,
                             }}
                       />
                    
                    <Button
                      type="submit"
                      variant="contained"
                      color="custom"
                      sx={{ width: 'fit-content' }}
                      disabled={buttonDisable}
                      onClick={()=>editResume()}
                    >
                      Save
                    </Button>
                   
                  </Stack>
               
              </Stack>
            {/* </>
          ) : null} */}
          
        </Box>
      </Grid>
</Stack>
    </>
  );
} 

export default ApplyJobPreview;
  